import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API испытаний для заключений элементов технических устройств
 */
@Injectable()
export class InspectionApiService extends ApiService {
    baseUrl = 'inspection';

    /**
     * Путь для создания и редактирования дефектов испытания
     * @param inspectionId
     */
    getDefectPath(inspectionId: number): string {
        return `${this.baseUrl}/${inspectionId}/defect`;
    }
}
